import { render, staticRenderFns } from "./RoundedTabs.vue?vue&type=template&id=4da90e28"
import script from "./RoundedTabs.vue?vue&type=script&lang=js"
export * from "./RoundedTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports